import styled from 'styled-components';

export const Container = styled.div({
  textAlign: 'center',
  padding: '0 5rem',
  width: '68rem',
  height: '68rem',
  bottom: '10rem',
});

export const WaterfallPreviewerImage = styled.img({
  width: '46rem',
  borderRadius: '5rem',
});

export const WaterfallName = styled.div({
  paddingTop: '5rem',
  textAlign: 'center',
  fontSize: '12px',
  width: '60px',
  fontWeight: 500,
  letterSpacing: '0.01px',
  lineHeight: '12px',
  height: '40px',
});
